<template>
  <section class="main">
    <h1 class="heading">
      {{ $t("AN ERROR OCCURED HERE ARE SOME DETAILS") }}
    </h1>
    <span class="status g-status g-status_error">
      {{ $t("NO_DEVICE_LINKED") }}
    </span>
    <router-link class="g-button" to="/link">{{
      $t("LINK_YOUR_DEVICE")
    }}</router-link>
  </section>
</template>

<script>
export default {
  computed: {
    title() {
      return this.$t('ERROR');
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.heading {
  font-size: 16px;
  font-weight: 500;
}

.status {
  margin: 10px 0;
}
</style>
